import { useState } from 'react'
import Formsy from 'formsy-react'
import useRequestPending from 'shared/hooks/useRequestPending'
import { createVehicle } from 'dashboard-vehicles/actions'
import { createVehiclePendingSelector } from 'dashboard-vehicles/selectors'
import ErrorMessage from '@components/ErrorMessage'
import Input from '@components/Textfield/withFormsy'
import Button from '@components/Button'
import InfoModal from '@components/InfoModal'

const INITIAL_STATE = {
    tag: '', // '1337',
    make: '', // 'Maserati',
    model: '', // 'Quattroporte',
    color: '', // 'Black'
}

const VehicleForm = ({ createVehicle, pending, translate: t, onSuccess }) => {
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
    const [formValues, setFormValues] = useState(INITIAL_STATE)
    const { error, isLoading } = useRequestPending(pending, () => {
        setIsInfoModalOpen(true)
    })

    const onChangeHandler = event => {
        const { value, name } = event.target

        setFormValues({
            ...formValues,
            [name]: value,
        })
    }

    const submitVehicle = async () => {
        const { tag, make, model, color } = formValues
        createVehicle(tag, make, model, color)
        setFormValues(INITIAL_STATE)
    }

    return (
        <>
            {isInfoModalOpen && (
                <InfoModal
                    title="dashboard.vehicles.warning.title"
                    text="dashboard.vehicles.warning.text"
                    onDismiss={() => {
                        if (onSuccess) {
                            onSuccess()
                        }
                        setIsInfoModalOpen(false)
                    }}
                />
            )}
            <Formsy onSubmit={submitVehicle}>
                <Input
                    className="mb-3"
                    required
                    value={formValues.tag}
                    name="tag"
                    placeholder={t('dashboard.vehicles.tag.label')}
                    onChange={onChangeHandler}
                    maxLength="10"
                />
                <Input
                    className="mb-3"
                    required
                    value={formValues.make}
                    name="make"
                    placeholder={t('dashboard.vehicles.make.label')}
                    onChange={onChangeHandler}
                    maxLength="20"
                />
                <Input
                    className="mb-3"
                    required
                    value={formValues.model}
                    name="model"
                    placeholder={t('dashboard.vehicles.model.label')}
                    onChange={onChangeHandler}
                    maxLength="20"
                />
                <Input
                    className="mb-3"
                    required
                    value={formValues.color}
                    name="color"
                    placeholder={t('dashboard.vehicles.color.label')}
                    onChange={onChangeHandler}
                    maxLength="20"
                />

                <Button isLoading={isLoading} disabled={isLoading}>
                    <T>dashboard.vehicles.add.btn.label</T>
                </Button>

                {error && <ErrorMessage className="vehicle-error" messages={[error]} />}
            </Formsy>
        </>
    )
}

const mapDispatchToProps = {
    createVehicle,
}

const mapStateToProps = createStructuredSelector({
    pending: createVehiclePendingSelector,
})

export default compose(withTranslate, connect(mapStateToProps, mapDispatchToProps))(VehicleForm)
